
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import debounce from 'lodash/debounce';
  import { Client, IDocumentModel, DocumentModel } from '@/services/api.service';
  import { DocumentType, DocumentTypeEnums } from '@/common/enumerations';
  import * as DateUtils from '@/utilities/date.utils';
  import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

  import toDateFormatter from '@/filters/todate.formatter';
  import toDocumentTypeFormatter from '@/filters/documenttype.formatter';
  import toFileSizeFormatter from '@/filters/filesize.formatter';

  import { NoFolder } from '../JobView.vue';

  @Component({
    props: {
      jobGid: String,
      documents: {
        type: Array as () => IDocumentModel[],
        required: true
      },
      folders: {
        type: Array as () => string[],
        required: false
      }
    },
    filters: {
      toDate: toDateFormatter,
      toDocumentType: toDocumentTypeFormatter,
      toFileSize: toFileSizeFormatter
    }
  })
  export default class JobDocumentList extends Vue {
    private selectedFolder: string = '';
    private filteredDocuments: IDocumentModel[] = [];

    @Watch('folders', { immediate: false, deep: true })
    private onFoldersChanged() {
      if (this.selectedFolder === '') {
        if (this.$props.folders) {
          if (this.$props.folders.length > 0) {
            console.log('onFoldersChanged:Setting default selected folder to:', this.$props.folders[0]);
            this.selectedFolder = this.$props.folders[0];
          }
        }
      }
    }

    @Watch('documents', { immediate: false, deep: true })
    private onDocumentsChanged() {
      this.filterDocuments();
    }

    private filterDocuments() {
      if (this.selectedFolder === NoFolder || !this.$props.documents) {
        // if the selected folder name is the same as the no folder name that means we need to filter for documents without a folder
        // we also filter for the NoFolder string name just in case someone names a folder the same thing
        this.filteredDocuments = this.$props.documents.filter(
          (d: IDocumentModel) => d.folderName === null || d.folderName === NoFolder
        );
      } else {
        this.filteredDocuments = this.$props.documents.filter(
          (d: IDocumentModel) => d.folderName === this.selectedFolder
        );
      }
    }
    @Watch('selectedFolder')
    private onSelectedFolderChanged(value: string, oldValue: string) {
      console.log('Selected folder changed:', value);
      this.filterDocuments();
      console.log('Selected folder changed:', this.filteredDocuments);
    }
    private downloadDocument(documentGid: string, fileName: string) {
      const baseUrl = process.env.VUE_APP_API_URL;
      const downloadUrl = baseUrl + '/api/v1/file/documents/' + documentGid + '/download';
      axios({
        method: 'get',
        url: downloadUrl,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      })
        .then((response: any) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(reason => {
          // @ts-ignore
          this.$awn.alert('Unable to download the file\r\n' + reason.message);
        });
    }

    private deleteJobDocument(document: IDocumentModel) {
      this.$emit('on-delete-jobdocument', document);
    }
  }
